import { Component, Inject, Input } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
   selector: 'client-verification-modal',
   templateUrl: './client-verification-modal.component.html',
   styleUrls: ['./client-verification-modal.component.scss'],
   standalone: false,
})
export class ClientVerificationModalComponent {
   constructor(private dialogRef: MatDialogRef<ClientVerificationModalComponent>, @Inject(MAT_DIALOG_DATA) public data: { practiceSKey: number }) {}

   close() {
      this.dialogRef.close()
   }
}
